import { Navigate, Outlet } from 'react-router';
import { PageLoader } from './page-loader';
import { useCurrentUser } from '@/hooks/use-current-user';

export function AccountAdminGate() {
  const { isLoading, isAccountAdmin } = useCurrentUser();
  if (isLoading) return <PageLoader />;
  if (!isAccountAdmin) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
